import eventNames from 'src/analytics/eventNames';
import track from 'src/analytics/track';

import { ADD_TO_HOMESCREEN_EVENT_DATA } from './eventData';

export function trackAddToHomescreenBannerClose() {
  track(eventNames.clicked, {
    site: 'main',
    module_name: ADD_TO_HOMESCREEN_EVENT_DATA.moduleName,
    flow: ADD_TO_HOMESCREEN_EVENT_DATA.flow,
    component: 'button',
    text: 'x',
    type: 'exit',
  });
}
